<template>
	<c-dialog ref="dialog" :title="'【'+this.workTypeName+'】导入记录'" enable-flex width="1000" mode="slide" mask-close :button="false">
		<m-search ref="search" column="4" @search="searchHandle" :default-data="defaultSearchData">
			<m-search-item label="导入时间" colspan="2">
				<c-datetime start-name="start_date" end-name="end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</m-search-item>
		</m-search>

		<c-table ref="list" height="grow">
			<c-table-column
				label="导入时间"
				name="create_date"
				width="130"
			></c-table-column>

			<c-table-column
				label="导入用户"
				name="create_user_realname"
				width="80"
			>
			</c-table-column>

			<c-table-column
				label="导入结果"
				name="state"
				width="70"
			>
				<template #default="{data}">
					<c-state dict="importStateName" :value="data.state"></c-state>
				</template>
			</c-table-column>

			<c-table-column
				label="导入详情"
				name="remark"
				width="550"
				:ellipsis="false"
			>
			<template #default="{data}">
				<span v-if="data.remark">
					上传<a v-if="data.upload_file_url"  style="color: #44f;" @click="downloadFile(data.upload_file_url,1)">源文件</a>成功，{{data.remark}}
				</span>
				<a v-if="data.error_file_url && data.state!=2" style="color:red;" @click="downloadFile(data.error_file_url,2)">
					&nbsp;&nbsp;下载错误报告
				</a>
			</template>
      </c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'importLogDetail',

		computed: {
			// 获取dictName选项数据
			...mapState(['importStateName']),
			workTypeName() {
				return {
					1:'销售订单',
					3:'工单',
					4:'入库单',
					5:'出库单',
					6:'盘点单',
					7:'产品信息',
					8:'不良品项',
					9:'工序',
					10:'工艺路线',
					15:'物料清单',
					27:'用户',
					31:'绩效工资配置',
					39:'采购单'
				}[this.workType]
			}
		},

		props: {
			view_id: [String, Number],
			workType: [String, Number]
		},

		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					start_date: new Date(now.getFullYear(), now.getMonth(), 1).format('yyyy-MM-dd') +' 00:00',
					end_date: new Date(now.getFullYear(), now.getMonth() + 1, 0).format('yyyy-MM-dd')+' 23:59'
				}
			}
		},
		
		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				data.view_id = this.view_id;
				data.work_type = this.workType;
				this.$refs.list.load({
					url: '/import/log/list',
					data
				});
			},
			/************打开新增、编辑弹窗**************/
			open() {
				this.searchHandle();
				this.$refs.dialog.open();
			},
			/**
			 *
			 * @param file_url     文件地址
			 * @param type         1=上传文件  2=错误报告
			 */
			downloadFile(file_url,type){
				var fineName = ''
				if (type == 1){
					var index = file_url.lastIndexOf("\/");
					fineName = file_url.substring(index + 1,file_url.length);
				}else {
					var index = file_url.lastIndexOf('.');
					fineName = this.workTypeName + "导入_错误报告"+file_url.substring(index,file_url.length);
				}
				this.download({
					fileName:fineName,
					url: file_url,
					loading: {
						message: '数据文件生成中...'
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
